import { render, staticRenderFns } from "./ButtonTalk.vue?vue&type=template&id=74c64051&scoped=true&"
import script from "./ButtonTalk.vue?vue&type=script&lang=js&"
export * from "./ButtonTalk.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTalk.vue?vue&type=style&index=0&id=74c64051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c64051",
  null
  
)

export default component.exports